import { provider } from '~/api/provider/provider.config';
import { handleRejectedRequest } from '~/api/provider/providerErrors';

import { GetBannersResponse } from './bannersApiTypes';

const namespace = Symbol('namespace');

export const bannersApi = {
  [namespace]: '/v1/banners',

  async get(favoriteGenres?: string) {
    try {
      const response = await provider.get<GetBannersResponse>(
        this[namespace],
        { params: favoriteGenres ? { favoriteGenres } : undefined },
      );
      return response.data;
    } catch (error) {
      return await handleRejectedRequest<void>(error);
    }
  },
};
